import { json } from "react-router-dom";
import { handle_error } from "./wretch";

/**
 * The dialer's write endpoints answer `400` with `{error, field_errors, graph_issues}`
 * and `409` with `{error, blockers}`. `handle_error` flattens a body to a string, which
 * would lose the per-field errors the node form has to display, so those two statuses
 * are passed through structured and everything else falls back to the shared helper.
 */
async function readBody(error: any): Promise<Record<string, unknown>> {
    if (error?.json != null && typeof error.json === "object") return error.json;
    if (typeof error?.response?.json === "function") {
        const body = await error.response.json().catch(() => null);
        if (body && typeof body === "object") return body;
    }
    if (typeof error?.message === "string") {
        try {
            const parsed = JSON.parse(error.message);
            if (parsed && typeof parsed === "object") return parsed;
        } catch (_error) {
            return { error: error.message };
        }
    }
    return {};
}

export async function handle_dialer_error(error: any) {
    const status = error?.response?.status;
    if (status === 400 || status === 409) {
        const body = await readBody(error);
        return json({
            success: false,
            message: {
                ...body,
                error:
                    body.error ??
                    (status === 409 ? "Someone changed this workflow while you were editing. Reload to continue from the latest version." : "The submitted configuration is invalid."),
                status
            }
        });
    }
    return handle_error(error);
}
